/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type { HTTP401NotAuthenticatedErrorResponse } from "../../models/hTTP401NotAuthenticatedErrorResponse.ts";

import type { HTTPValidationError } from "../../models/hTTPValidationError.ts";

import type { UserAttribution } from "../../models/userAttribution.ts";

import type { UserAttributionInput } from "../../models/userAttributionInput.ts";

import { customMutator } from "../../../mutators/custom-mutator.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export type postAnalyticsReportUserAttributionResponse200 = {
  data: UserAttribution;
  status: 200;
};

export type postAnalyticsReportUserAttributionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postAnalyticsReportUserAttributionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postAnalyticsReportUserAttributionResponseSuccess =
  postAnalyticsReportUserAttributionResponse200 & {
    headers: Headers;
  };
export type postAnalyticsReportUserAttributionResponseError = (
  | postAnalyticsReportUserAttributionResponse401
  | postAnalyticsReportUserAttributionResponse422
) & {
  headers: Headers;
};

export type postAnalyticsReportUserAttributionResponse =
  | postAnalyticsReportUserAttributionResponseSuccess
  | postAnalyticsReportUserAttributionResponseError;

export const getPostAnalyticsReportUserAttributionUrl = () => {
  return `/api/analytics/attribution`;
};

/**
 * Store where this user came from. Fields are only ever filled once.
 *
 * The DataFast ids come from the request headers the frontend attaches to
 * every call, so the body never has to carry them.
 * @summary Report user attribution
 */
export const postAnalyticsReportUserAttribution = async (
  userAttributionInput: UserAttributionInput,
  options?: RequestInit,
): Promise<postAnalyticsReportUserAttributionResponse> => {
  return customMutator<postAnalyticsReportUserAttributionResponse>(
    getPostAnalyticsReportUserAttributionUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(userAttributionInput),
    },
  );
};

export const getPostAnalyticsReportUserAttributionMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAnalyticsReportUserAttribution>>,
    TError,
    { data: UserAttributionInput },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAnalyticsReportUserAttribution>>,
  TError,
  { data: UserAttributionInput },
  TContext
> => {
  const mutationKey = ["postAnalyticsReportUserAttribution"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAnalyticsReportUserAttribution>>,
    { data: UserAttributionInput }
  > = (props) => {
    const { data } = props ?? {};

    return postAnalyticsReportUserAttribution(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAnalyticsReportUserAttributionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAnalyticsReportUserAttribution>>
>;
export type PostAnalyticsReportUserAttributionMutationBody =
  UserAttributionInput;
export type PostAnalyticsReportUserAttributionMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Report user attribution
 */
export const usePostAnalyticsReportUserAttribution = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAnalyticsReportUserAttribution>>,
      TError,
      { data: UserAttributionInput },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAnalyticsReportUserAttribution>>,
  TError,
  { data: UserAttributionInput },
  TContext
> => {
  return useMutation(
    getPostAnalyticsReportUserAttributionMutationOptions(options),
    queryClient,
  );
};
